<template>
  <div>
    <page-title title="Add Allergen Collection Set" :helpLink="{ path: '/pages/station-collector-help', hash: 'AllergenCollectionSet_Add' }" />
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3" border-variant="primary" header="Primary" header-bg-variant="primary" header-text-variant="white" v-if="existingAllergenCollectionSetId">
            <h4 slot="header">Collection Already Exists</h4>
            <p>There's already an existing allergen collection set for this station and date. Would you like to edit the existing allergen collection set? If you choose "No", you'll need to choose a different station or date.</p>
            <b-button-toolbar key-nav>
              <b-button-group>
                <b-button variant="primary" @click="goToExisting">Yes</b-button>
              </b-button-group>
              <b-button-group class="mx-2">
                <b-button @click="existingAllergenCollectionSetId = null">No</b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-card>
          <b-card class="mt-3">
            <h4 slot="header">Collection Details</h4>
            <select-control label="Station" v-model="item.stationId" :options="stations" required></select-control>
            <date-picker-control label="Date" v-model="item.date" type="date" description="This defaults to today's date, cannot exceed today's date" :customValidation="customDateValidation"></date-picker-control>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group>
              <b-button type="submit" variant="primary">
                Create
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "AllergenCollectionSetAdd",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      existingAllergenCollectionSetId: null,
      stations: [],
      item: {
        stationId: null,
        date: new Date().toJSON().slice(0,10),
        comment: '',
        weatherNotes: '',
        isCommentPublic: false
      },
      customDateValidation: function(newValue, oldValue) {
        if(newValue)
        {
          const now = new Date();
          const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          const dateVal = new Date(newValue);
          if (dateVal > today)
            return "Selected date cannot be past Today's date";
        }
        return true;
      }
    };
  },
  methods: {
    load: function () {

      this.readQuery('/graphql/management', {
        query: `
          query {
            stations (limit: 1000, order: "displayCity") {
              id,
              name,
              displayCity,
              state
            }
          }`,
        variables: { }
      }, (data) => {
        this.stations = data.stations.filter(s => s.displayCity).map(s =>  {
          return {
            value: s.id,
            text: s.displayCity + ', ' + s.state + ': ' + s.name
          };
        });

        if (this.stations.length > 1)
          this.stations.unshift({
            value: null,
            text: ''
          });

        if (this.stations.length > 0)
          this.item.stationId = this.stations[0].value;
      });
    },
    onCancel(evt) {
      this.$router.push('/allergenCollectionSet');
    },
    onSubmit(evt) {
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; })) {

        this.readQuery('/graphql/management', {
          query: `
              query ($filter: String) {
                allergenCollectionSets (filter: $filter) {
                  id,
                  date
                }
              }`,
          variables: {
            filter: 'stationId="' + this.item.stationId + '" and date="' + this.item.date + '"'
          }
        }, (data) => {
          if (data.allergenCollectionSets.length > 0) {
            this.existingAllergenCollectionSetId = data.allergenCollectionSets[0].id;
          } else {
            let stationName = this.stations.find(x => x.value == this.item.stationId).text;

            this.createQuery('/graphql/management', {
              query: `
                mutation ($allergenCollectionSet: AllergenCollectionSetCreateInputOGT!) {
                  createAllergenCollectionSet(allergenCollectionSet: $allergenCollectionSet) {
                    id
                  }
                }`,
              variables: {
                'allergenCollectionSet': this.item
              }}, (data) => {
                this.$router.push('/allergenCollectionSet/' + data.createAllergenCollectionSet.id);
              }, null, 'Allergen Collection Set', stationName + ' (' + this.item.date + ')');
          }
        });
      }
    },
    goToExisting() {
      this.$router.push('/allergenCollectionSet/' + this.existingAllergenCollectionSetId);
    }  
  },
  mounted () {
    this.load();
  }
};
</script>